<template>
  <LvDropdownMultiCategorySelect
    :value="value"
    outline
    label="風險"
    title="自訂風險"
    :scroll="scroll"
    :scope="_effectScope"
    :menuItems="effectList"
    :createUrl="_effectCreateUrl"
    :createFields="effect.createFields"
    :updateFields="effect.updateFields"
    :isLoadingItems="isLoading.list"
    :deletePopupContentText="effect.deleteText"
    @created="$_getEffectList()"
    @delete="$_onDeleteFactoryEffect($event)"
    @update="$_onUpdateFactoryEffect($event)"
    @input="$emit('input', $event)"
    @toggle="$_onToggleEffectList($event)"
  />
</template>

<script>
import S_scope from '@/service/api/v1/scope';
import S_factoryEffect from '@/service/api/v1/factoryEffect';
import H_factoryEffect from '@/helpers/factoryEffect';
import Spare_factoryEffect from '@/spare/factoryEffect';

export default {
  props: {
    value: {
      type: Array,
    },
    scroll: {
      type: [Number, String],
    }
  },
  data() {
    return {
      isLoading: {
        list: false,
      },
      effectList: [],
      effect: {
        createFields: Spare_factoryEffect.createFields,
        updateFields: Spare_factoryEffect.updateFields,
        deleteText: '',
      },
    }
  },
  computed: {
    _templateEffect() {
      return this.$store.state.model.effect;
    },
    _effectScope() {
      return {
        isCreatable: S_scope.$_isAvailable(['factory-effect-create']),
        isUpdatable: S_scope.$_isAvailable(['factory-effect-update']),
        isDeletable: S_scope.$_isAvailable(['factory-effect-delete']),
      };
    },
    _effectCreateUrl() {
      return S_factoryEffect.createUrl();
    },
  },
  async mounted() {
    await this.$_getEffectList();
  },
  methods: {
    async $_getEffectList() {
      this.isLoading.list = true;
      const params = {
        order_by: 'sequence',
        order_way: 'asc',
        get_all: 1,
      };
      const res = await S_factoryEffect.index(params);
      this.effectList = H_factoryEffect.setDropdownCustomItems(this._templateEffect, res);
      this.isLoading.list = false;
    },
    async $_onDeleteFactoryEffect($event) {
      const {value: id} = $event;
      await S_factoryEffect.delete(id);
      await this.$_getEffectList();
    },
    async $_onUpdateFactoryEffect($event) {
      const {value: id, name} = $event;
      const data = {
        name,
      };
      await S_factoryEffect.update(id, data);
      await this.$_getEffectList();
    },
    async $_onToggleEffectList($event) {
      const isMenuShow = $event;
      if (isMenuShow && !this.effectList.length) await this.$_getEffectList();
    },
  }
}
</script>